import translate from "@insite/client-framework/Translate";
import { AttributeTypeFacetModel } from "@insite/client-framework/Types/ApiModels";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Select, { SelectProps } from "@insite/mobius/Select";
import Typography from "@insite/mobius/Typography";
import React, { useEffect, useMemo, useState } from "react";
import { css } from "styled-components";


export interface ModelPickerProps {
    isEnabled?: boolean;
    modelFacet?: AttributeTypeFacetModel;
    selectedModel?: string;
    onModelSelect: (model: string) => void;
}

export const ModelPicker: React.FC<ModelPickerProps> = ({
    isEnabled,
    modelFacet,
    selectedModel,
    onModelSelect,
}) => {
    const [models, setModels] = React.useState<{ attributeValueId: string; value: string }[]>([]);

    useEffect(() => {
        if (modelFacet?.attributeValueFacets) {
            const sortedModels = [...modelFacet.attributeValueFacets]
                .sort((a, b) => a.value.localeCompare(b.value));
            setModels(sortedModels);
        }
    }, [modelFacet]);

    const handleStateChange: SelectProps["onChange"] = event => {
        onModelSelect(event.target.value);
    };

    return (
        <Select
            name="model"
            value={selectedModel}
            data-test-selector="ymm_model"
            onChange={handleStateChange}
            disabled={!isEnabled}
        >
            <option value="">{translate("Model")}</option>
            {models.map((row) => (
                <option key={row.attributeValueId} value={row.attributeValueId}>
                    {row.value}
                </option>
            ))}
        </Select>
    );
};